import React from 'react';
import { Card, Space, Avatar, Typography, Button, Popconfirm } from 'antd';
import { DeleteOutlined, RocketOutlined, StarOutlined } from '@ant-design/icons';

const { Text, Title } = Typography;

export const EvolucionCard = ({
  evolucion,
  onDelete,
  isDeleting = false,
}) => {
  const {
    idReqPok,
    nombrePokemonDestino,
    numeroDexDestino,
    cantidadRequerimiento,
    nombreObjeto,
    descripcionRequerimiento,
    pokemonDestino // Este campo contendrá la info del Pokémon destino
  } = evolucion;

  return (
    <Card
      style={{
        borderRadius: '12px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        border: '1px solid #f0f0f0',
        marginBottom: '16px',
        overflow: 'hidden'
      }}
      bodyStyle={{ padding: '16px' }}
      extra={
        <Popconfirm
          title="¿Eliminar evolución?"
          description="¿Está seguro que desea eliminar este requerimiento de evolución?"
          onConfirm={() => onDelete(idReqPok)}
          okText="Sí, eliminar"
          cancelText="Cancelar"
          okType="danger"
        >
          <Button
            type="text"
            danger
            icon={<DeleteOutlined />}
            loading={isDeleting}
            style={{
              borderRadius: '6px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          />
        </Popconfirm>
      }
    >
      {/* Header con ID y Pokémon Destino */}
      <div style={{ marginBottom: '12px' }}>
        <Space align="start" style={{ width: '100%', justifyContent: 'space-between' }}>
          {nombrePokemonDestino && (
            <Space>
              <RocketOutlined style={{ color: '#52c41a' }} />
              <Text strong style={{ color: '#52c41a' }}>
                → {nombrePokemonDestino + ` (#${numeroDexDestino})`}
              </Text>
            </Space>
          )}
        </Space>
      </div>

      {/* Descripción del Requerimiento */}
      <div style={{ marginBottom: '12px' }}>
        <Text style={{
          color: '#262626',
          fontSize: '13px',
          lineHeight: '1.4',
          display: 'block'
        }}>
          {descripcionRequerimiento}
        </Text>
      </div>

      {/* Información de Cantidad y Objeto */}
      <div style={{
        backgroundColor: '#fafafa',
        padding: '8px 12px',
        borderRadius: '6px',
        border: '1px solid #f0f0f0'
      }}>
        <Space split={<span style={{ color: '#d9d9d9' }}>|</span>} style={{ width: '100%' }}>
          <Space>
            <Avatar
              size="small"
              style={{ backgroundColor: '#52c41a', fontSize: '12px' }}
            >
              {cantidadRequerimiento}
            </Avatar>
            <Text style={{ fontSize: '12px', color: '#52c41a', fontWeight: '600' }}>
              {cantidadRequerimiento === 1 ? '1 unidad' : `${cantidadRequerimiento} unidades`}
            </Text>
          </Space>

          <Space>
            {nombreObjeto === null ? (
              <Text
                type="secondary"
                style={{ fontSize: '12px', fontStyle: 'italic' }}
              >
                No asignado
              </Text>
            ) : (
              <Text
                style={{ fontSize: '12px', color: '#1890ff', fontWeight: '600' }}
              >
                {nombreObjeto}
              </Text>
            )}
          </Space>
        </Space>
      </div>
    </Card>
  );
};
